// removed by extract-text-webpack-plugin
module.exports = {"panel":"collapse__panel-3XnN6","wrapper":"collapse__wrapper-5v8QZ","innerWrapper":"collapse__innerWrapper-3qB0I","headerClickable":"collapse__headerClickable-142CT","header":"collapse__header-1KVb3","collapsed":"collapse__collapsed-1oQ2v","content":"collapse__content-1ntD7","arrow":"collapse__arrow-3_Vl1"};


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/orders-navigation/collapse/collapse.css
// module id = 768
// module chunks = 0